import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusOrdem',
  standalone: true
})
export class StatusOrdemPipe implements PipeTransform {

  private statusMap: { [key: string]: string } = {
    CANCELADO: 'Cancelado',
    EM_ATENDIMENTO: 'Em Atendimento',
    AGUARDANDO_ENVIO: 'Aguardando Envio',
    FINALIZADO: 'Finalizado'
  };

  transform(value: string): string {
    return this.statusMap[value] || value;
  }
}
